import React, { useMemo, useState } from 'react';
import Select from 'react-select';
import { useAppTheme, buildReactSelectTheme } from '@theme';

const ReactSelect = ({ options, className, onChange, onKeyDown, defaultValue, value, isDisabled = false, ...rest }: any) => {
    const [isClearable] = useState(false);
    const [isSearchable] = useState(false);
    const [isLoading] = useState(false);
    const { tokens } = useAppTheme();

    const selectTheme = useMemo(
        () => buildReactSelectTheme(tokens),
        [tokens],
    );

    return (
        <Select
            className={`basic-single ${className}`}
            classNamePrefix="select"
            defaultValue={defaultValue}
            value={value}
            isDisabled={isDisabled}
            isLoading={isLoading}
            isClearable={isClearable}
            isSearchable={isSearchable}
            name="color"
            onChange={onChange}
            onKeyDown={onKeyDown}
            options={options}
            theme={selectTheme}
            {...rest}
        />
    );
};

export default ReactSelect;
